import React from 'react';
import { useTranslation } from 'react-i18next';
import Constant from '../Constant';

export default function LandingPageCopyright(props) {
  const { t } = useTranslation();
  return (
    <div className="copyright">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <p className="p-small">
              <span className="mr-2">
                {t('Copyright (c) {{year}}', {
                  year: new Date().getFullYear(),
                })}
              </span>
              <a
                href="https://bina.asia"
                target="_blank"
                rel="noopener noreferrer"
                className="mr-2"
              >
                {Constant.APP_NAME}
              </a>
              <span>{t('All rights reserved')}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
